/* ================================================================ */
// ADMIN CONTAINER | Sidebar.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useEffect, useCallback, useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
//import 'url-search-params-polyfill';
import { useDispatch, useSelector } from 'react-redux';
// Hooks
import useReactRouter from 'use-react-router';
// Material UI
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import makeStyles from '@material-ui/styles/makeStyles';
// Auth0
import { useAuth0 } from '../auth0/auth0';
// Components
import RowEditor from '../components/Admin/RowEditor';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        margin: '2em',
        marginTop: '4em',
        height: 'calc(100vh - 8em)'
        // position:'absolute',
        // top:'10px',
        // left:'10px',
        // // height:'100px',
        // // width:'200px',
        // border:'1px solid black',
        // background:'#fff',
        // zIndex:'2',
    },
    loadingContainer: {
    },
    user: {
        padding: '1em',
        width: '10em'
    }
}));
/* ========================================== */
/**
 * Admin Component
 * ---------------
 * Admin Edit Modal (To be continued)
 *
 * @component
 * @param {object} props component properties
 */
const Admin = (props) => {
    const { isAuthenticated, loginWithRedirect, logout, getTokenSilently,loading,user } = useAuth0();
    const count = useSelector(state => state.Data.count);
    const classes = useStyles();
    const [loaded, setLoaded] = useState(false);
    // const rootClasses = classNames(classes.root, {
    //     'expanded': true
    // });
    // useEffect(()=>{
    //     /* ======================== */
    //     // COMPONENT UPDATE
    //     /* ======================== */
    //     if(category && page && !popup)
    //         setExpanded(true);
    //     else
    //         setExpanded(false);
    // }, [category, popup, page]);



    // const callAPI = async ()=>{
    //     try {
    //     var token = await getTokenSilently();
    //     console.log(token);
    //     const response = await fetch("http://localhost:3000/graphql", {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //           "Content-Type":"application/json",
    //         },
    //         method: "POST",
    //         body: JSON.stringify({query: "{\n  allUsers {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n","variables": null})
    //     });
    //     const responseData = await response.json();
    //     console.log(responseData);
    //     } catch(e) {
    //         console.error(e);
    //     }
    // }
    // if (loading || !user) {
    // return <div>Loading...</div>;
    // }
    const callApi = useCallback(async (/*user*/) => {
        //let query = `{accountIdByEmail(e: "${user.email}")}`;
        let query = '{myId}';
        try {
            var token = await getTokenSilently();
            console.log(token);
            const response = await fetch('https://api.myglobe.app/graphql', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type':'multipart/json',
                },
                method: 'POST',
                body: JSON.stringify({query})
            });
            const responseData = await response.json();
            console.log('data',responseData.data.myId);
            if(responseData.data.myId==null)
                console.error('Error: no valid globe user found');
            let accId = responseData.data.myId;
            // FETCH GLOBES
            // query = `{allGlobes(condition: {account: "${accId}"}) {
            //   edges {
            //     node {
            //       id
            //       pagesByGlobeId {
            //         nodes {
            //           content
            //           name
            //           slug
            //           style
            //           type
            //           nodeId
            //         }
            //         pageInfo {
            //           startCursor
            //           endCursor
            //         }
            //       }
            //       visLayersByGlobeId {
            //         nodes {
            //           config
            //           lastUpdated
            //           name
            //           stateLayersByLayerId {
            //             nodes {
            //               layerId
            //               nodeId
            //               stateId
            //             }
            //           }
            //         }
            //       }
            //     }
            //   }
            // }}`;
            // query = `{
            //     a: jwtEnvVar(v: "jwt.claims.user_email"),
            //     b: jwtEnvVar(v: "jwt.claims.user_id"),
            //   }`;
            const globereq = await fetch('https://api.myglobe.app/graphql', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type':'application/json',
                },
                method: 'POST',
                body: JSON.stringify({query})
            });
            const globeResponseData = await globereq.json();
            console.log(globeResponseData);
        } catch(e) {
            console.error(e);
        }
    }, [getTokenSilently]);

    useEffect(()=>{
        console.log('isAuthenticated',isAuthenticated/*,user*/);
        //console.log(prevAuth.current,isAuthenticated);
        // if(isAuthenticated)
        //     callApi();
        //user&&callApi(user);
    }, [isAuthenticated /*user*/]);
    return (
        <Paper className={classes.root}>
            {(loading) &&
                <div className={classes.loadingContainer}>
                    <Skeleton animation="wave" variant="rect" height="3rem" />
                    <LinearProgress />
                </div>
            }
            { isAuthenticated && <RowEditor authState={isAuthenticated} datasetID={'gea-members'} /> }
            {/* {isAuthenticated && <button onClick={() => upload()}>Upload</button>} */}        
            {isAuthenticated&&user&&<h2>{user.name}</h2>}
            {isAuthenticated && <button onClick={() => logout()}>Log out</button>}
        </Paper>
    );
};

export default Admin;